import {
  getCommonProductTerms,
  getVerticalWidgetProductTerms,
  ServicesWithTerms,
} from '@sravni/react-ugc/lib/ProductTerms';
import { OTHER_OFFERS } from '@sravni/ugc/lib/specialOffers/lists';
import type { OtherOffersType } from '@sravni/ugc/lib/specialOffers/types';

import type { OfferTab } from '../../helpers/getTabsInfo';

export const otherTabsInfo: Record<OtherOffersType, OfferTab> = {
  [OTHER_OFFERS.bukmekery]: {
    key: { type: OTHER_OFFERS.bukmekery },
    label: 'Букмекеры',
    generalLink: '/sport/bukmekery/',
    generalLinkLabel: 'Все ставки на спорт онлайн',
    advertisingCategory: 'Букмекеры',
    getConditions: getCommonProductTerms(ServicesWithTerms.bukmekery),
    getVerticalWidgetConditions: getVerticalWidgetProductTerms(ServicesWithTerms.bukmekery),
  },
};
